<div class="screen-container">
  <app-card>
    <div left-content>
      <div class="tm">
        <p>TM</p>
      </div>
      <span
        *ngIf="isLoading"
        class="icon icon-loading"
      ></span>
      <div *ngIf="!isLoading" class="text-container">

        <div *ngIf="success" class="w4rAnimated_checkmark">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
            <circle class="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
            <polyline class="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 "/>
          </svg>
        </div>

        <h2 class="center" *ngIf="success">{{ 'telemarketing.emailSent.confirmation' | translate }}</h2>
        <h2 class="center error" *ngIf="!success">{{ 'telemarketing.emailSent.error' | translate }}</h2>
        <p>{{ email }}</p>

        <div actions class="actions" *ngIf="!success"> 
          <button mat-flat-button color="primary" (click)="tryAgain()">
            {{ 'telemarketing.emailSent.tryAgain' | translate }}
          </button>
        </div>
      </div>
    </div>
    <div right-content>
      <div class="text-container">
        <h2 class="center">{{ 'telemarketing.emailSent.return' | translate }}</h2>
      </div>
      <div actions class="actions restart">
        <button mat-flat-button (click)="atlProTmButton()">/atl-pro-tm</button>
        <button mat-flat-button (click)="atlNlTmButton()">/atl-nl-tm</button>
      </div>
    </div>
  </app-card>
</div>
